var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SwaggerParser from '@apidevtools/swagger-parser';
import cloneDeep from 'lodash/cloneDeep';
const flatten = ($data, refs, maxDepth) => {
    function flattenRefs($data, refs, d) {
        if (d > maxDepth) {
            return {};
        }
        let data = cloneDeep($data);
        if (data && typeof data === 'object') {
            if ('$ref' in data) {
                const ref = data['$ref'];
                data = flattenRefs(refs.get(ref), refs, d + 1);
            }
            else {
                for (const key in data) {
                    data[key] = flattenRefs(data[key], refs, d + 1);
                }
            }
        }
        return data;
    }
    return flattenRefs($data, refs, 0);
};
export function dereferencePath(jsonData, httpMethod, endpointPath, maxDepth = 13) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const refs = yield SwaggerParser.resolve(jsonData);
        const api = yield SwaggerParser.parse(jsonData);
        const operationObject = cloneDeep((_b = (_a = api.paths) === null || _a === void 0 ? void 0 : _a[endpointPath]) === null || _b === void 0 ? void 0 : _b[httpMethod]);
        if (!operationObject)
            return {};
        return flatten(operationObject, refs, maxDepth);
    });
}
// async function main() {
//   const json = await Bun.file(
//     '/Users/sudhanshugautam/workspace/intevene/src/server/openapi/stripe.json',
//   ).json();
//   const o = JSON.stringify(
//     await dereferencePath(
//       json,
//       OpenAPIV2.HttpMethods.POST,
//       '/v1/subscriptions/{subscription_exposed_id}',
//     ),
//   );
//   await Bun.write('/tmp/output.json', o);
// }
// main().then(() => {
//   process.exit(0);
// });
